var map = {
	"./About/Index.vue": [
		"b6d9",
		"chunk-2d21045f"
	],
	"./Error/Index.vue": [
		"9cd1",
		"chunk-8372f950"
	],
	"./Hero/HeroAttributes/Index.vue": [
		"2fb3",
		"chunk-03779ea3",
		"chunk-41399944"
	],
	"./Hero/HeroItems/Index.vue": [
		"1c7d",
		"chunk-3148ed1a"
	],
	"./Hero/HeroSkills/Index.vue": [
		"3d5c",
		"chunk-2d0c4e15"
	],
	"./Hero/Index.vue": [
		"55f5",
		"chunk-03779ea3",
		"chunk-f7dda28c"
	],
	"./Home/Index.vue": [
		"8a00",
		"chunk-b79fcb78"
	],
	"./Profile/ArtisansBlock/Index.vue": [
		"6447",
		"chunk-322cb424"
	],
	"./Profile/Index.vue": [
		"1da4",
		"chunk-03779ea3",
		"chunk-4ff76c25",
		"chunk-5f6d4e00"
	],
	"./Profile/MainBlock/HeroesList/Index.vue": [
		"7397",
		"chunk-03779ea3",
		"chunk-58570212"
	],
	"./Profile/MainBlock/Index.vue": [
		"81ac",
		"chunk-03779ea3",
		"chunk-4ff76c25"
	],
	"./Profile/MainBlock/PlayerStats/Index.vue": [
		"5581",
		"chunk-03779ea3",
		"chunk-d35d6656"
	],
	"./Profile/MainBlock/ProgressList/Index.vue": [
		"e5e5",
		"chunk-22e06287"
	],
	"./Profile/MainBlock/TopHeroes/Index.vue": [
		"6205",
		"chunk-03779ea3",
		"chunk-89a22ac4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3b5e";
module.exports = webpackAsyncContext;